"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TickCircleIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-78.000000, -344.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(79.000000, 345.000000)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M14.2983895,7.2874393 C14.6919259,6.89995054 15.3250719,6.90485313 15.7125607,7.29838954 C16.0702426,7.66165391 16.0935793,8.22908268 15.785526,8.61900032 L15.7016105,8.7125607 L9.60796671,14.7125607 C9.24862987,15.0663755 8.6885754,15.0935462 8.29841072,14.7941049 L8.20462339,14.7124402 L6.29826714,12.8347347 C5.9047973,12.4471783 5.90000347,11.8140315 6.28755983,11.4205616 C6.64530416,11.0573587 7.21230901,11.0253353 7.60689838,11.3273814 L7.70173286,11.4098543 L8.906,12.596 L14.2983895,7.2874393 Z M10.5,22 C4.14872538,22 -1,16.8512746 -1,10.5 C-1,4.14872538 4.14872538,-1 10.5,-1 C16.8512746,-1 22,4.14872538 22,10.5 C22,16.8512746 16.8512746,22 10.5,22 Z M10.5,20 C15.7467051,20 20,15.7467051 20,10.5 C20,5.25329488 15.7467051,1 10.5,1 C5.25329488,1 1,5.25329488 1,10.5 C1,15.7467051 5.25329488,20 10.5,20 Z",
          fill: color,
          fillRule: "nonzero"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          strokeWidth: "1",
          fillRule: "evenodd",
          transform: "translate(-1.000000, -1.000000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  transform: "translate(11.500000, 11.500000) rotate(-180.000000) translate(-11.500000, -11.500000) translate(0.000000, 0.000000)"
                })
              })
            })
          })
        })]
      })
    })
  })]
});

TickCircleIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = TickCircleIcon;
exports.default = _default;